import { CircularProgress, Stack, Typography } from '@mui/material'
import { ProjectsList } from '../../../../components/ProjectsPage/ProjectsList'
import { useLazyGetSubscribedProjectsPageQuery } from '../../../../api/projects'
import { EMPTY_PROJECTS_QUERY_ARGS, useProjectsWindowedPage } from '../../../../hooks/useProjectsWindowedPage'

export const ProjectsSubscriptions = () => {
  const [loadPage] = useLazyGetSubscribedProjectsPageQuery()
  const {
    items,
    hasMore,
    isInitialLoading,
    isFetchingMore,
    isError,
    loadMore,
  } = useProjectsWindowedPage('subscriptions', loadPage, EMPTY_PROJECTS_QUERY_ARGS)

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить проекты
      </Typography>
    )
  }

  return (
    <ProjectsList
      projects={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore && hasMore}
      onLoadMore={() => void loadMore()}
    />
  )
}
